/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'user',
        title: 'Contributors Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/contributors-management'
    },
    // {
    //     id   : 'user',
    //     title: 'User Whitelisting',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/user-whitelisting'
    // },
    {
        id: 'user',
        title: 'Round Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/round'
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '/report',
        children: [
            {
                id: 'report.type',
                title: 'Contribution and AOC Balance',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-1',
            },
            {
                id: 'report.type',
                title: 'Referral AOC bonus',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-2',
            },
            {
                id: 'report.type',
                title: 'Referral USDT bonus',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-3',
            },
            {
                id: 'report.type',
                title: 'Recap USDT-AOC bonus',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-4',
            },
            {
                id: 'report.type',
                title: 'Recap AOC bonus',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-5',
            },
            {
                id: 'report.type',
                title: 'Recap total AOC to receive',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-6',
            },
            {
                id: 'report.type',
                title: 'Minor Contributors',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-7',
            },
            {
                id: 'report.type',
                title: 'Junior Contributors',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-8',
            },
            {
                id: 'report.type',
                title: 'Senior Contributors',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-9',
            },
            {
                id: 'report.type',
                title: 'Super Senior Contributors',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-10',
            },
            {
                id: 'report.type',
                title: 'Contributors Statistic Record',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-11',
            },
            // {
            //     id: 'report.type',
            //     title: 'Contributors Statistic Record',
            //     type: 'basic',
            //     icon: 'heroicons_outline:menu-alt-1',
            //     link: '/reports/report-11',
            // },
            {
                id: 'report.type',
                title: 'Contributors Global Data',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-12',
            },
            {
                id: 'report.type',
                title: 'USDT bonus CLAIMED/PAID',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/reports/report-13',
            },
        ]
    },
    {
        id: 'leaderboard',
        title: 'Leaderboard Management',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'report.type',
                title: 'Top Sponsers',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/top-sponsers',
            },
            {
                id: 'report.type',
                title: 'Top Country',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/top-country',
            },
        ]
    },
    {
        id: 'user',
        title: 'Total USDT BEP20',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/total-usdt-data'
    },
    {
        id: 'withdraw',
        title: 'TOTAL USDT BEP20 Direct Bonus Withdrawn',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/usdt-withdraw-list'
    },
    {
        id: 'announcement',
        title: 'Announcement Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/announcement-management'
    },
    {
        id: 'whitelist',
        title: 'Whitelist Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/whitelist-management'
    },
    {
        id: 'influencer',
        title: 'Crypto-Martkets and Crypto-Influencers',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/crypto-influencers'
    },
    {
        id: 'collaborative contribution',
        title: 'Collaborative Contribution Management',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '/collaborative-contribution',
        children: [
            {
                id: 'collaborative contribution',
                title: 'May 18, 2024 - Aug 28, 2024',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/may18Aug28',
            },
            {
                id: 'collaborative contribution',
                title: 'Aug 29, 2024 - Jan 25, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/aug29Jan25',
            },
            {
                id: 'collaborative contribution',
                title: 'Jan 26, 2025 – Feb 20, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/jan26Feb20',
            },
            {
                id: 'collaborative contribution',
                title: 'Feb 21, 2025 – Mar 05, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/feb21Mar5',
            },
            {
                id: 'collaborative contribution',
                title: 'After Mar 05, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/afterMar5',
            },
            {
                id: 'set timer',
                title: 'Set Timer',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/set-timer/hash',
            }
        ]
    },
    {
        id: 'rapture collaborative distribution parent',
        title: 'Rapture Collaborative Contribution Management',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        children: [
            {
                id: 'rapture collaborative contribution',
                title: 'Rapture Collaborative Contribution',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/rapture-collaborative-distribution',
            },
            {
                id: 'deleted rapture collaborative contribution',
                title: 'Rapture Deleted Collaborative Contribution',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-rapture-collaborative-distribution',
            }
        ]
    },
    {
        id: 'deleted collaboratives',
        title: 'Deleted Collaborative Contributions',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '/deleted-collaboratives',
        children: [
            {
                id: 'delete collaborative',
                title: 'May 18, 2024 - Aug 28, 2024',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/may18Aug28',
            },
            {
                id: 'delete collaborative',
                title: 'Aug 29, 2024 - Jan 25, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/aug29Jan25',
            },
            {
                id: 'delete collaborative',
                title: 'Jan 26, 2025 – Feb 20, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/jan26Feb20',
            },
            {
                id: 'delete collaborative',
                title: 'Feb 21, 2025 – Mar 05, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/feb21Mar5',
            },
            {
                id: 'delete collaborative',
                title: 'After Mar 05, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/afterMar5',
            }
        ]
    },
    {
        id: 'AOC WEB3  Accounting and Statistical Sheet (AOC WEB3 ASS)',
        title: 'AOC WEB3  Accounting and Statistical Sheet (AOC WEB3 ASS)',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'distributed by category',
                title: 'STATISTICS AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY CATEGORY',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'accounting-statistical-sheet/category'
            },
            {
                id: 'distributed by initiatives',
                title: 'STATISTICS AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY INITIATIVE',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'accounting-statistical-sheet/initiative'
            },
            {
                id: 'distributed by holders',
                title: 'DIRECTORY OF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED TO HOLDERS',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'accounting-statistical-sheet/holders'
            },
            {
                id: 'corretion user list',
                title: 'CORRECTION USER LIST',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'accounting-statistical-sheet/corretion-user-list',
            }

        ]
    },
    {
        id: 'internal id collaborative contribution ',
        title: 'Internal ID - Collaborative Contribution Management',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '/collaborative-contribution',
        children: [
            {
                id: 'internal-id',
                title: 'May 18, 2024 - Aug 28, 2024',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/internal-id/may18Aug28',
            },
            {
                id: 'internal-id',
                title: 'Aug 29, 2024 - Jan 25, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/internal-id/aug29Jan25',
            },
            {
                id: 'internal-id',
                title: 'Jan 26, 2025 – Feb 20, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/internal-id/jan26Feb20',
            },
            {
                id: 'internal-id',
                title: 'Feb 21, 2025 – Mar 05, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/internal-id/feb21Mar5',
            },
            {
                id: 'internal-id',
                title: 'After Mar 05, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/internal-id/afterMar5',
            },
            {
                id: 'set timer',
                title: 'Set Timer',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/set-timer/internal-id',
            }
        ]
    },
    {
        id: 'internal id deleted collaboratives',
        title: 'Internal ID - Deleted Collaborative Contributions',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '/deleted-collaboratives',
        children: [
            {
                id: 'report.type',
                title: 'May 18, 2024 - Aug 28, 2024',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/internal-id/may18Aug28',
            },
            {
                id: 'report.type',
                title: 'Aug 29, 2024 - Jan 25, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/internal-id/aug29Jan25',
            },
            {
                id: 'report.type',
                title: 'Jan 26, 2025 – Feb 20, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/internal-id/jan26Feb20',
            },
            {
                id: 'report.type',
                title: 'Feb 21, 2025 – Mar 05, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/internal-id/feb21Mar5',
            },
            {
                id: 'report.type',
                title: 'After Mar 05, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/deleted-collaboratives/internal-id/afterMar5',
            }
        ]
    },
    {
        id: 'miracle matrix ',
        title: 'Miracle Matrix Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/miracle-matrix'
    },
    {
        id: 'thanks giving contributions',
        title: 'Flash Operation',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'report.type',
                title: 'Jan 26, 2025 – Feb 20, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'flash-operation-matrix-users/jan26Feb20',
            },
            {
                id: 'report.type',
                title: 'Feb 21, 2025 – Mar 05, 2025',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'flash-operation-matrix-users/feb21Mar5',
            },
        ]
    },
    {
        id: 'banner management',
        title: 'Banner Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/banner-management'
    },
    {
        id: 'visitor management',
        title: 'Visitor Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/visitor-management'
    },
    {
        id: 'audio announcement',
        title: 'Audio Announcement',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/audio-announcement'
    },
    {
        id: 'NewsLetter Management',
        title: 'NewsLetter Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/newsletter-management'
    },
    {
        id: 'booking kit management',
        title: 'Booking Kit Management',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'Global Directory',
                title: 'Global Directory',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'booking-kit/global-directory',
            },
            {
                id: 'Statistics',
                title: 'Global Statistics',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'booking-kit/statistics',
            },
            {
                id: 'Statistics',
                title: 'Country Statistics',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'booking-kit/country-statistics',
            },
            {
                id: 'Shipping Directory',
                title: 'Personal Booking Shipping Directory',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'booking-kit/shipping-directory',
            },
            {
                id: 'Shipping Directory',
                title: 'Group Booking Shipping Directory',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'booking-kit/group-shipping-directory',
            },
            {
                id: 'Deleted Booking Kits',
                title: 'Deleted Booking kits',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'booking-kit/deleted-booking-kit',
            },
            {
                id: 'Set timer',
                title: 'Set Timer',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'booking-kit/set-timer',
            }
        ]
    },
    {
        id: 'Internal ID - AOC WEB3  Accounting and Statistical Sheet (AOC WEB3 ASS)',
        title: 'Internal ID - AOC WEB3  Accounting and Statistical Sheet (AOC WEB3 ASS)',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'internal distributed by category',
                title: 'INTERNAL ID - STATISTICS AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY CATEGORY',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'accounting-statistical-sheet/internal-id/category'
            },
            {
                id: 'internal distributed by initiatives',
                title: 'INTERNAL ID - STATISTICS AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY INITIATIVE',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'accounting-statistical-sheet/internal-id/initiative'
            },
            {
                id: 'internal distributed by holders',
                title: 'INTERNAL ID - DIRECTORY OF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED TO HOLDERS',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'accounting-statistical-sheet/internal-id/holders'
            }

        ]
    },
    {
        id: 'ÉWLIZO MAVƆMAVƆ AVÍVI Initiative',
        title: 'ÉWLIZO MAVƆMAVƆ AVÍVI Initiative-54th Initiative',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'ewlizo mavomavo avivi distributed by category',
                title: 'STATISTICS AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY CATEGORY',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'ewlizo-mavomavo-avivi-accounting-statistical-sheet/category'
            },
            {
                id: 'ewlizo mavomavo avivi distributed by initiatives',
                title: 'STATISTICS AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY INITIATIVE',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'ewlizo-mavomavo-avivi-accounting-statistical-sheet/initiative'
            },
            {
                id: 'ewlizo mavomavo avivi distributed by holders',
                title: 'DIRECTORY OF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED TO HOLDERS',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'ewlizo-mavomavo-avivi-accounting-statistical-sheet/holders'
            }
        ]
    },
    {
        id: 'Rapture Distribution Statistics',
        title: 'Rapture Distribution Statistics',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'rapture distribution statistics by category',
                title: 'STATISTICS AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY CATEGORY',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'rapture-distribution-statistics/category'
            },
            {
                id: 'rapture distribution statistics by initiatives',
                title: 'STATISTICS AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY INITIATIVE',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'rapture-distribution-statistics/initiative'
            },
            {
                id: 'rapture distribution statistics by holders',
                title: 'DIRECTORY OF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED TO HOLDERS',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'rapture-distribution-statistics/holders'
            }
        ]
    },
    {
        id: 'amc-user-details',
        title: 'AMC users details',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/amc/statistics/user-list'
    },
    {
        id: 'Aggressive Marketing Campaign ',
        title: 'Aggressive Marketing Campaign',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'Aggressive Marketing Campaign by category',
                title: 'Aggressive Marketing Campaign by category',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'amc/statistics/category'
            },
            {
                id: 'Aggressive Marketing Campaign by season',
                title: 'Aggressive Marketing Campaign by season',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'amc/statistics/season'
            },
            {
                id: 'Aggressive Marketing Campaign by holders',
                title: 'Aggressive Marketing Campaign by holders',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'amc/statistics/holders'
            }

        ]
    },
    {
        id: 'Aggressive Marketing Campaign - collaborative',
        title: 'Aggressive Marketing Campaign - collaborative',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'Resurrection',
                title: 'Resurrection',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'aggressive-marketing/Resurrection/1'
            },
            // {
            //     id: 'Omega',
            //     title: 'Omega',
            //     type: 'collapsable',
            //     icon: 'heroicons_outline:menu-alt-1',
            //     link: '',
            //     children: [
            //         {
            //             id: 'Round 1',
            //             title: 'Round 1',
            //             type: 'basic',
            //             icon: 'heroicons_outline:menu-alt-1',
            //             link: 'aggressive-marketing/Omega/1'
            //         },
            //         {
            //             id: 'Round 2',
            //             title: 'Round 2',
            //             type: 'basic',
            //             icon: 'heroicons_outline:menu-alt-1',
            //             link: 'aggressive-marketing/Omega/2'
            //         },
            //         {
            //             id: 'Round 3',
            //             title: 'Round 3',
            //             type: 'basic',
            //             icon: 'heroicons_outline:menu-alt-1',
            //             link: 'aggressive-marketing/Omega/3'
            //         },
            //         {
            //             id: 'Round 4',
            //             title: 'Round 4',
            //             type: 'basic',
            //             icon: 'heroicons_outline:menu-alt-1',
            //             link: 'aggressive-marketing/Omega/4'
            //         }
            // 
            //     ]
            // },
            {
                id: 'set timer',
                title: 'Set Timer',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/set-timer/aggressive-marketing',
            }

        ]
    },
    {
        id: 'Deleted Aggressive Marketing Campaign - collaborative',
        title: 'Deleted Aggressive Marketing Campaign - collaborative',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'Resurrection',
                title: 'Resurrection',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'deleted-aggressive-marketing/Resurrection/1/trashed'
            },
            // {
            //     id: 'Omega',
            //     title: 'Omega',
            //     type: 'collapsable',
            //     icon: 'heroicons_outline:menu-alt-1',
            //     link: '',
            //     children: [
            //         {
            //             id: 'Round 1',
            //             title: 'Round 1',
            //             type: 'basic',
            //             icon: 'heroicons_outline:menu-alt-1',
            //             link: 'deleted-aggressive-marketing/Omega/1/trashed'
            //         },
            //         {
            //             id: 'Round 2',
            //             title: 'Round 2',
            //             type: 'basic',
            //             icon: 'heroicons_outline:menu-alt-1',
            //             link: 'deleted-aggressive-marketing/Omega/2/trashed'
            //         },
            //         {
            //             id: 'Round 3',
            //             title: 'Round 3',
            //             type: 'basic',
            //             icon: 'heroicons_outline:menu-alt-1',
            //             link: 'deleted-aggressive-marketing/Omega/3/trashed'
            //         },
            //         {
            //             id: 'Round 4',
            //             title: 'Round 4',
            //             type: 'basic',
            //             icon: 'heroicons_outline:menu-alt-1',
            //             link: 'deleted-aggressive-marketing/Omega/4/trashed'
            //         }
            // 
            //     ]
            // }
        ]
    },
    {
        id: 'SAF Management ',
        title: 'Solidarity Africa Alpha Omega Coin (SAF-AOC)',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'SAF User Details',
                title: 'Position Taking History',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'saf/position-taking-history/users',
            },
            {
                id: 'SAF-AOC Position Taking Statistics upon Performance',
                title: 'SAF-AOC Position Taking Statistics upon Performance',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/saf/position-taking-history/performance',
            },
            {
                id: 'SAF-AOC Position Taking Statistics',
                title: 'SAF-AOC Position Taking Statistics',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/saf/position-taking-history/statistics',
            },
            {
                id: 'set timer',
                title: 'Set Timer',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: '/collaborative-contribution/set-timer/saf-contribution',
            },
        ]
    },
    // {
    //     id: 'SAF collaborative Management',
    //     title: 'SAF-AOC Position Taking Collaborative Registration Management',
    //     type: 'collapsable',
    //     icon: 'heroicons_outline:chart-pie',
    //     link: '',
    //     children: [
    //         {
    //             id: 'SAF-AOC administration',
    //             title: 'SAF-AOC administration Management',
    //             type: 'basic',
    //             icon: 'heroicons_outline:menu-alt-1',
    //             link: 'saf/position-taking-history/administration',
    //         },
    //         {
    //             id: 'SAF-AOC root user management',
    //             title: 'SAF-AOC root user management',
    //             type: 'basic',
    //             icon: 'heroicons_outline:menu-alt-1',
    //             link: 'saf/position-taking-history/root-users',
    //         },
    //         {
    //             id: 'SAF-AOC manifestation',
    //             title: 'SAF-AOC manifestation',
    //             type: 'basic',
    //             icon: 'heroicons_outline:menu-alt-1',
    //             link: 'saf/position-taking-history/manifestation',
    //         },
    //         {
    //             id: 'SAF-AOC position taking collaborative',
    //             title: 'SAF-AOC position taking collaborative',
    //             type: 'basic',
    //             icon: 'heroicons_outline:menu-alt-1',
    //             link: 'saf/position-taking-history/collaborative',
    //         },
    //         {
    //             id: 'Deleted SAF-AOC position taking collaborative',
    //             title: 'Deleted SAF-AOC position taking collaborative',
    //             type: 'basic',
    //             icon: 'heroicons_outline:menu-alt-1',
    //             link: 'saf/position-taking-history/deleted-collaborative',
    //         },
    //         {
    //             id: 'saf tree details',
    //             title: 'SAF Tree Details',
    //             type: 'basic',
    //             icon: 'heroicons_outline:menu-alt-1',
    //             link: '/saf/position-taking-history/tree-details',
    //         },
    //         {
    //             id: 'set timer',
    //             title: 'Set Timer',
    //             type: 'basic',
    //             icon: 'heroicons_outline:menu-alt-1',
    //             link: '/collaborative-contribution/set-timer/saf-collaborative-contribution',
    //         }

    //     ]
    // },
    {
        id: 'saf-token-reg-collaborative',
        title: 'SAF Token Registration Collaborative Space',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'saf-token-reg-collaborative-list',
                title: 'SAF Token Registration Collaborative',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'saf/position-taking-history/token-reg-collaborative',
            },
            {
                id: 'deleted-saf-token-reg-collaborative-list',
                title: 'Deleted SAF Token Registration Collaborative',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'saf/position-taking-history/deleted-token-reg-collaborative',
            },
            {
                id: 'saf-token-reg-set-timer',
                title: 'Set Timer',
                type: 'basic',
                icon: 'heroicons_outline:clock',
                link: 'saf/position-taking-history/token-reg-set-timer',
            }
        ]
    },
    {
        id: 'SAF AOC Contribution Accounting and Statistical Sheet',
        title: 'SAF AOC Contribution Accounting and Statistical Sheet',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'saf distributed by category',
                title: 'STATISTICS SAF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY CATEGORY',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'saf-accounting-statistical-sheet/category'
            },
            {
                id: 'saf distributed by initiatives',
                title: 'STATISTICS SAF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY INITIATIVE',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'saf-accounting-statistical-sheet/initiative'
            },
            {
                id: 'saf distributed by holders',
                title: 'DIRECTORY OF SAF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED TO HOLDERS',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'saf-accounting-statistical-sheet/holders'
            }
        ]
    },
    {
        id: 'POST-SAF AOC Contribution Accounting and Statistical Sheet',
        title: 'POST-SAF AOC Contribution Accounting and Statistical Sheet',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        // One sub-menu per initiative space. The token space has all three sheets; the non-token
        // space has no by-category sheet. Each page sends its space to the API as `is_token`.
        children: [
            {
                id: 'post-saf-accounting-token-space',
                title: 'Token Initiative Space',
                type: 'collapsable',
                icon: 'heroicons_outline:collection',
                link: '',
                children: [
                    {
                        id: 'post-saf token distributed by category',
                        title: 'STATISTICS POST-SAF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY CATEGORY',
                        type: 'basic',
                        icon: 'heroicons_outline:menu-alt-1',
                        link: 'post-saf-accounting-statistical-sheet/token/category'
                    },
                    {
                        id: 'post-saf token distributed by initiatives',
                        title: 'STATISTICS POST-SAF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED BY INITIATIVE',
                        type: 'basic',
                        icon: 'heroicons_outline:menu-alt-1',
                        link: 'post-saf-accounting-statistical-sheet/token/initiative'
                    },
                    {
                        id: 'post-saf token distributed by holders',
                        title: 'DIRECTORY OF POST-SAF AOC BEP20 TOKENS QUANTITY TO BE DISTRIBUTED TO HOLDERS',
                        type: 'basic',
                        icon: 'heroicons_outline:menu-alt-1',
                        link: 'post-saf-accounting-statistical-sheet/token/holders'
                    }
                ]
            },
            {
                id: 'post-saf-accounting-non-token-space',
                title: 'Non Token Initiative Space',
                type: 'collapsable',
                icon: 'heroicons_outline:collection',
                link: '',
                children: [
                    {
                        id: 'post-saf non-token distributed by initiatives',
                        title: 'STATISTICS POST-SAF USDT BEP20 QUANTITY CONTRIBUTED BY INITIATIVE',
                        type: 'basic',
                        icon: 'heroicons_outline:menu-alt-1',
                        link: 'post-saf-accounting-statistical-sheet/non-token/initiative'
                    },
                    {
                        id: 'post-saf non-token distributed by holders',
                        title: 'DIRECTORY OF POST-SAF USDT BEP20 QUANTITY CONTRIBUTED BY HOLDERS',
                        type: 'basic',
                        icon: 'heroicons_outline:menu-alt-1',
                        link: 'post-saf-accounting-statistical-sheet/non-token/holders'
                    }
                ]
            },
            {
                id: 'post-saf global holder wise sheet',
                title: 'Global Holder wise POST-SAF Accounting and Statistical Sheet',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: 'post-saf-accounting-statistical-sheet/global/holders'
            }
        ]
    },
    {
        id: 'post-saf-collaborative-space',
        title: 'POST-SAF AOC Collaborative Space',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'post-saf-token-received',
                title: 'Token Received Registrations',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'post-saf/token-received'
            },
            {
                id: 'post-saf-token-non-received',
                title: 'Non Token Received Registrations',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'post-saf/token-non-received'
            },
            {
                id: 'post-saf-token-reg-set-timer',
                title: 'Set Timer',
                type: 'basic',
                icon: 'heroicons_outline:clock',
                link: '/collaborative-contribution/set-timer/post-saf-token-registration-collaborative-contribution',
            },
            {
                id: 'post-saf-dagbemabu-name-change-request',
                title: 'Dagbemabu Family Name Change Request Management',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'post-saf/dagbemabu-name-change-request'
            },
            {
                id: 'post-saf-family-details-management',
                title: 'Family Details Management',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'post-saf/family-details-management'
            }
        ]
    },
    {
        id: 'deleted-post-saf-collaborative-space',
        title: 'Deleted POST-SAF AOC Collaborative Space',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        link: '',
        children: [
            {
                id: 'deleted-post-saf-token-received',
                title: 'Deleted Token Received Registrations',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'post-saf/deleted-token-received'
            },
            {
                id: 'deleted-post-saf-token-non-received',
                title: 'Deleted Non Token Received Registrations',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-1',
                link: 'post-saf/deleted-token-non-received'
            }
        ]
    },
    {
        id: 'sponsor-credit-increase',
        title: 'Sponsor Credit Increase',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/sponsor-credit-increase'
    },
    {
        id: 'sponsor-credit',
        title: 'Sponsor Credit Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/sponsor-credit',
        hidden: () => true
    },
    // {
    //     id: 'insufficient-sponsor-credit',
    //     title: 'Insufficient Sponsor Credit User Management',
    //     type: 'basic',
    //     icon: 'heroicons_outline:chart-pie',
    //     link: '/insufficient-sponsor-credit'
    // },
    {
        id: 'non-initiative-participants',
        title: 'Non-Initiative Adherents',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/non-initiative-participants'
    },

    {
        id: 'round-cap-statistics',
        title: 'Round Cap Statistics',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/round-cap-statistics'
    },
    {
        id: 'script',
        title: 'Script Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/script-management'
    },
    {
        id: 'transfer-ownership',
        title: 'Owner only contract functions',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/transfer-ownership'
    },
    {
        id: 'wallet-change-requests',
        title: 'Wallet Change Requests',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/wallet-change-requests'
    },
    {
        id: 'member-type-change-requests',
        title: 'Member Type Change Requests',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/member-type-change'
    },
    {
        id: 'contributor-type-change-requests',
        title: 'Contributor Type Change Requests',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/contributor-type-change'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
